import React from 'react';
import {
	Button,
	Grid,
  CircularProgress,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { getInputData } from '../../store/forms';
import InputField from '../../components/InputField';
import BasicError from '../../components/BasicError';

function CheckInLoginForm({ viewParameters, error, handleChange, handleLogin, mdUpScreen, loading, buttonPressed }) {
  const view = "login";
  const object = "checkinLogin";
  const reservationNumber = useSelector(getInputData(view, object, "reservationNumber"));
  const authorizationCode = useSelector(getInputData(view, object, "authorizationCode"));

  const { estilos } = viewParameters; 
  return (
    <Grid container spacing={0} sx={estilos.gridContainer}>
        <Grid item xs={12} sx={estilos.gridItem}>
            <InputField showValidation={buttonPressed} control={reservationNumber} handleChange={(e) => handleChange("reservationNumber", e)} small={!mdUpScreen} />
        </Grid>
        <Grid item xs={12} sx={estilos.gridItem}>
            <InputField showValidation={buttonPressed} control={authorizationCode} handleChange={(e) => handleChange("authorizationCode", e)} small={!mdUpScreen} />
        </Grid>
        {error !== '' && (<Grid item xs={12}>
            <BasicError error={error} />
        </Grid>)}
        <Grid item xs={12} sx={estilos.gridItem}>
            <Button disabled={loading} variant="contained" size={mdUpScreen ? 'medium' : 'small'} sx={estilos.submitButton} onClick={handleLogin}>
            {loading ? <CircularProgress /> : 'Ingresar'}
            </Button>
        </Grid>
    </Grid>
  );
}
export default CheckInLoginForm;